export default "__VITE_ASSET__DOkLSBSt__"